import { render } from "./SimpleSecretSelector.vue?vue&type=template&id=2abd8e3c"
import script from "./SimpleSecretSelector.vue?vue&type=script&lang=js"
export * from "./SimpleSecretSelector.vue?vue&type=script&lang=js"

import "./SimpleSecretSelector.vue?vue&type=style&index=0&id=2abd8e3c&lang=scss"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__